<template>
  <v-card class="pa-4">
    <v-card-text class="pb-0">
      <p class="pa-3 mb-0">
        Are you sure you want to delete the network <span class="font-weight-bold">{{ deleteLabelNetwork }}</span>?
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="coolgray"
        text
        @click.stop="cancelDeleteNetwork"
      >
        Cancel
      </v-btn>

      <v-btn
        color="toasted"
        text
        @click.stop="deleteNetwork"
      >
        Delete it
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import NetworkMixin from 'src/network/store/utils/networks-mixin'

export default {
  name: 'NetworkDelete',
  mixins: [
    NetworkMixin,
  ],
}
</script>
